"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    transition: prop_types_1.default.string,
    transitionDelay: prop_types_1.default.string,
    transitionDuration: prop_types_1.default.string,
    transitionProperty: prop_types_1.default.string,
    transitionTimingFunction: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const transition = {
    className: 'tstn',
    cssName: 'transition',
    jsName: 'transition',
    complexValue: true
};
const transitionDelay = {
    className: 'tstn-dly',
    cssName: 'transition-delay',
    jsName: 'transitionDelay',
    complexValue: true
};
const transitionDuration = {
    className: 'tstn-drn',
    cssName: 'transition-duration',
    jsName: 'transitionDuration',
    complexValue: true
};
const transitionProperty = {
    className: 'tstn-pty',
    cssName: 'transition-property',
    jsName: 'transitionProperty',
    complexValue: true
};
const transitionTimingFunction = {
    className: 'tstn-tf',
    cssName: 'transition-timing-function',
    jsName: 'transitionTimingFunction',
    complexValue: true
};
exports.propEnhancers = {
    transition: (value) => get_css_1.default(transition, value),
    transitionDelay: (value) => get_css_1.default(transitionDelay, value),
    transitionDuration: (value) => get_css_1.default(transitionDuration, value),
    transitionProperty: (value) => get_css_1.default(transitionProperty, value),
    transitionTimingFunction: (value) => get_css_1.default(transitionTimingFunction, value)
};
//# sourceMappingURL=transition.js.map